import { h } from "@stencil/core";

export const ZapierLogoIcon = () => (
  <svg
    width="155"
    height="42"
    viewBox="0 0 155 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="image"
  >
    <title>Zapier</title>
    <path
      d="M110.916 10.6407H104.018V34.435H110.916V10.6407Z"
      fill="var(--zapier-logo-text)"
    />
    <path
      d="M107.54 7.78552C108.056 7.80149 108.57 7.7113 109.05 7.52057C109.53 7.32984 109.965 7.04266 110.329 6.67687C110.684 6.30222 110.96 5.86 111.14 5.37661C111.32 4.89322 111.401 4.37857 111.377 3.8634C111.401 3.35025 111.317 2.83777 111.131 2.35874C110.945 1.8797 110.661 1.44467 110.297 1.08143C109.933 0.718185 109.497 0.434738 109.017 0.24922C108.537 0.0637023 108.023 -0.0198139 107.509 0.00402341C106.992 -0.0195829 106.477 0.060871 105.992 0.24057C105.507 0.420269 105.064 0.695529 104.689 1.04992C104.319 1.41048 104.029 1.84432 103.838 2.3235C103.646 2.80268 103.558 3.31657 103.577 3.83202C103.559 4.35199 103.648 4.87017 103.839 5.35424C104.03 5.83831 104.32 6.27788 104.689 6.6455C105.059 7.02175 105.504 7.3173 105.995 7.51351C106.486 7.70973 107.012 7.80235 107.54 7.78552Z"
      fill="var(--zapier-logo-text)"
    />
    <path
      d="M119.786 33.5146C121.782 34.605 124.031 35.1498 126.306 35.0939C128.159 35.1518 130.005 34.8426 131.737 34.184C133.063 33.6706 134.241 32.8369 135.165 31.7575C136.008 30.7045 136.619 29.4855 136.958 28.1805L131.014 26.528C130.741 27.3776 130.236 28.1345 129.556 28.714C128.655 29.393 127.538 29.7237 126.411 29.6448C125.627 29.7027 124.84 29.5779 124.112 29.2802C123.384 28.9825 122.736 28.5201 122.218 27.9295C121.384 26.7532 120.924 25.3539 120.897 23.9133H137.241C137.299 23.4308 137.33 22.9454 137.335 22.4595V21.1521C137.376 19.1614 136.964 17.1874 136.13 15.3787C135.347 13.7319 134.082 12.3606 132.502 11.4461C130.644 10.4255 128.541 9.93005 126.422 10.0133C122.564 10.0133 119.544 11.108 117.364 13.2974C115.173 15.4938 114.093 18.5269 114.093 22.3653C114.038 24.6929 114.545 26.9994 115.571 29.0905C116.521 30.9386 117.984 32.4747 119.786 33.5146ZM126.202 15.2637C129.158 15.2637 130.762 16.9023 131.014 20.1794H120.981C121.092 19.0235 121.504 17.9166 122.176 16.9685C122.666 16.3893 123.286 15.9331 123.985 15.637C124.684 15.3408 125.444 15.2129 126.202 15.2637Z"
      fill="var(--zapier-logo-text)"
    />
    <path
      d="M147.336 22.2399C147.244 20.9737 147.617 19.7171 148.385 18.7048C149.097 17.8785 150.481 17.4706 152.379 17.4706H155V10.6409H153.626C152.749 10.6081 151.876 10.7802 151.077 11.1433C150.278 11.5065 149.575 12.0507 149.024 12.7327C148.254 13.7645 147.705 14.9427 147.41 16.1946H147.105L146.33 10.6723H140.448V34.456H147.336V22.2399Z"
      fill="var(--zapier-logo-text)"
    />
    <path
      d="M27.6771 28.6198V34.4559H49.5145V28.6407H36.5567L36.368 28.0759L49.3153 16.4664V10.6407H28.0755V16.4664H40.2574L40.4671 17.0521L27.6771 28.6198Z"
      fill="var(--zapier-logo-text)"
    />
    <path
      d="M58.9812 18.3701C59.1592 17.5864 59.6131 16.8925 60.2603 16.4142C61.0202 15.9458 61.9052 15.7196 62.7973 15.7658C63.3203 15.7219 63.8465 15.7929 64.3392 15.9735C64.8318 16.1542 65.2788 16.4403 65.6488 16.8117C66.2859 17.6544 66.5985 18.6974 66.5294 19.7507V20.7966H60.3336C57.1815 20.7966 54.9171 21.4659 53.5402 22.8047C52.8456 23.4831 52.3004 24.2985 51.9393 25.199C51.5783 26.0994 51.4095 27.065 51.4435 28.0342C51.3645 29.0082 51.5127 29.9872 51.8765 30.8945C52.2403 31.8018 52.8097 32.6127 53.5402 33.2637C55.128 34.4617 57.0872 35.0651 59.0756 34.9685C60.1119 35.0067 61.1438 34.8155 62.0972 34.4086C63.0506 34.0017 63.9019 33.3893 64.5899 32.6152C65.3659 31.7157 65.9604 30.6752 66.3407 29.5507H66.7286L67.4834 34.4665H73.3123V19.6774C73.4783 17.092 72.6113 14.5462 70.9011 12.5967C69.2866 10.9233 66.7076 10.0866 63.0489 10.0866C61.1726 10.0339 59.3039 10.3429 57.545 10.9965C56.1946 11.5114 55.0147 12.3914 54.1378 13.538C53.3038 14.6888 52.7607 16.0236 52.5548 17.4288L58.9812 18.3701ZM61.4973 29.4148C60.5735 29.5122 59.6464 29.2623 58.8973 28.714C58.4399 28.2388 58.1845 27.6054 58.1845 26.9465C58.1845 26.2875 58.4399 25.6542 58.8973 25.1789C59.4348 24.7022 60.1398 24.4577 60.8578 24.4991H66.5504V25.3044C66.5627 25.8706 66.4443 26.4321 66.2044 26.9453C65.9644 27.4586 65.6093 27.9098 65.1666 28.2643C64.1178 29.0829 62.8057 29.492 61.4763 29.4148H61.4973Z"
      fill="var(--zapier-logo-text)"
    />
    <path
      d="M84.0886 29.5193H84.4345C84.638 30.1076 84.8905 30.6779 85.1893 31.2241C85.8546 32.4942 86.8789 33.5415 88.1352 34.2363C89.3236 34.8495 90.6448 35.162 91.9827 35.1463C93.2794 35.1988 94.5678 34.9163 95.7231 34.3263C96.8783 33.7363 97.8614 32.8587 98.5769 31.7785C100.118 29.5402 100.894 26.4025 100.894 22.3654C100.894 18.3282 100.139 15.452 98.6293 13.2556C97.8828 12.1769 96.8704 11.3082 95.6898 10.733C94.5092 10.1578 93.2 9.89551 91.8884 9.97144C90.8608 9.93516 89.837 10.1147 88.8834 10.4985C87.9298 10.8823 87.0677 11.4617 86.353 12.1992C85.3325 13.3343 84.5771 14.6809 84.141 16.1422H83.8579L83.0821 10.6199H77.2008V41.2438H84.0991L84.0886 29.5193ZM89.1207 16.1632C89.8439 16.0998 90.5715 16.2189 91.2365 16.5095C91.9015 16.8001 92.4825 17.2529 92.9262 17.8262C93.7912 19.2038 94.2052 20.8157 94.1109 22.4386C94.2097 24.1213 93.7968 25.7946 92.9262 27.2393C92.4951 27.8222 91.9226 28.2864 91.2625 28.5882C90.6024 28.8901 89.8762 29.0197 89.1522 28.965C88.4454 28.9992 87.7406 28.8642 87.0968 28.5713C86.453 28.2784 85.8889 27.836 85.4514 27.2811C84.4954 25.947 84.0256 24.3268 84.12 22.6896V22.2399C84.0063 20.6232 84.4788 19.0196 85.4514 17.7216C85.9072 17.2045 86.4735 16.7961 87.1085 16.5263C87.7436 16.2566 88.4312 16.1325 89.1207 16.1632Z"
      fill="var(--zapier-logo-text)"
    />
    <path
      d="M23.8502 28.6199H0V34.4455H23.8502V28.6199Z"
      fill="var(--zapier-logo-underline)"
    />
  </svg>
);

export const EllipsesIcon = () => {
  const size = 24;
  // Pick an even number for best results so that radius is an integer
  const diameter = 4;
  const gap = 3;
  const center = size / 2;
  const radius = diameter / 2;
  return (
    <svg
      aria-hidden="true"
      viewBox={`0 0 ${size} ${size}`}
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle r={radius} cy={center} cx={center - diameter - gap} />
      <circle r={radius} cy={center} cx={center} />
      <circle r={radius} cy={center} cx={center + diameter + gap} />
    </svg>
  );
};

export const TimeIcon = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 22 22"
    width="22"
    height="22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 11.25C0 5.3375 4.8375 0.5 10.75 0.5C16.6625 0.5 21.5 5.3375 21.5 11.25C21.5 17.1625 16.6625 22 10.75 22C4.8375 22 0 17.1625 0 11.25ZM9.675 12.325L15.265 15.765L16.125 14.3675L11.2875 11.465V5.875H9.675V12.325Z" />
  </svg>
);

export const WarningIcon = () => (
  <svg
    aria-hidden="true"
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="#CE482D"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 20H23.5L11.75 0.0300293L0 20ZM11.75 16.75C11.06 16.75 10.5 16.19 10.5 15.5C10.5 14.81 11.06 14.25 11.75 14.25C12.44 14.25 13 14.81 13 15.5C13 16.19 12.44 16.75 11.75 16.75ZM12.75 13H10.75V8.00003H12.75V13Z" />
  </svg>
);

export const EvergreenAiIcon = ({ size = "24" }) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={size}
    width={size}
    name="miscEvergreenAI"
  >
    <path
      fill="currentColor"
      d="M2 11h4.385A4.615 4.615 0 0 0 11 6.384V2h2v4.384A4.615 4.615 0 0 0 17.616 11H22v2h-4.384A4.615 4.615 0 0 0 13 17.615V22h-2v-4.385A4.615 4.615 0 0 0 6.385 13H2v-2Z"
    ></path>
    <path
      fill="currentColor"
      d="m4 18.586 3.536-3.536 1.414 1.415L5.414 20 4 18.586ZM18.586 4 15.05 7.536l1.414 1.414L20 5.414 18.586 4ZM5.414 4 8.95 7.536 7.535 8.95 4 5.414 5.414 4ZM20 18.586l-3.535-3.536-1.415 1.415L18.586 20 20 18.586Z"
    ></path>
  </svg>
);

export const PlusAppIcon = () => (
  <svg
    aria-hidden="true"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.875 26H0L0 24H0.875L0.875 26ZM4.375 26H2.625L2.625 24H4.375L4.375 26ZM7.875 26L6.125 26L6.125 24L7.875 24L7.875 26ZM11.375 26H9.625V24H11.375V26ZM14 26H13.125V24H14V26Z"
      fill="var(--icon-color)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.875 26H36V24H36.875V26ZM40.375 26H38.625V24H40.375V26ZM43.875 26L42.125 26V24L43.875 24V26ZM47.375 26H45.625V24H47.375V26ZM50 26H49.125V24H50V26Z"
      fill="var(--icon-color)"
    />
    <circle cx="25" cy="25" r="11" fill="var(--icon-color)" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26 20H24V24H20V26H24V30H26V26H30V24H26V20Z"
      fill="white"
    />
  </svg>
);

export const MagnifyingGlassIcon = () => (
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.2929 15.2929C15.6834 14.9024 16.3166 14.9024 16.7071 15.2929L20.7071 19.2929C21.0976 19.6834 21.0976 20.3166 20.7071 20.7071C20.3166 21.0976 19.6834 21.0976 19.2929 20.7071L15.2929 16.7071C14.9024 16.3166 14.9024 15.6834 15.2929 15.2929Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5 17C14.0899 17 17 14.0899 17 10.5C17 6.91014 14.0899 4 10.5 4C6.91014 4 4 6.91014 4 10.5C4 14.0899 6.91014 17 10.5 17ZM10.5 19C15.1944 19 19 15.1944 19 10.5C19 5.80557 15.1944 2 10.5 2C5.80557 2 2 5.80557 2 10.5C2 15.1944 5.80557 19 10.5 19Z"
    />
  </svg>
);

export const ClearButtonIcon = () => (
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.0346 6.24949C14.7937 3.00858 9.49044 3.00858 6.24953 6.24949C3.00863 9.49039 3.00863 14.7937 6.24953 18.0346C9.49044 21.2755 14.7937 21.2755 18.0346 18.0346C21.2756 14.7937 21.2756 9.49039 18.0346 6.24949ZM14.4991 15.6776L12.1421 13.3206L9.78507 15.6776L8.60656 14.4991L10.9636 12.142L8.60656 9.78502L9.78507 8.60651L12.1421 10.9635L14.4991 8.60651L15.6776 9.78502L13.3206 12.142L15.6776 14.4991L14.4991 15.6776Z" />
  </svg>
);

export const ArrowRightIcon = () => (
  <svg
    aria-hidden="true"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
      fill="#fff"
    />
  </svg>
);

export const ArrowSmallLeftIcon = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
  </svg>
);

export const ArrowSmallRightIcon = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
  </svg>
);

export const CloseIcon = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.29 6.29 12 10.59l-4.29-4.3-1.42 1.42 4.3 4.29-4.3 4.29 1.42 1.42 4.29-4.3 4.29 4.3 1.42-1.42-4.3-4.29 4.3-4.29-1.42-1.42Z" />
  </svg>
);
